import {
    Popover,
    PopoverTrigger,
    PopoverContent,
    PopoverBody, 
    PopoverArrow,
    Button,
    Flex,
    Box
  } from '@chakra-ui/react';
  import { MdMoreVert as MoreIcon } from "react-icons/md";


const TablePopUp = (props:any) => {
    const options = props.options;
    const click= props.click || function(){};
  return (
    <Popover closeOnBlur={false}>
        <PopoverTrigger>
            <Button onClick={click} bg="var(--cipm-light-green)" color="var(--dark-green-color)">
                <MoreIcon />
            </Button>
        </PopoverTrigger>
        <PopoverContent w="fit-content">
            <PopoverArrow />
            {/* <PopoverCloseButton /> */}
            <PopoverBody as={Flex} flexDir="column" p="10px 0" >
                {
                    options && options?.length > 0
                    ?options.map((eOption:any,index:number) =>
                    <Box sx={{':hover':{
                        bg:"var(--table-highlight)"
                    },'cursor':'pointer'}} p="5px 10px" key={index} onClick={eOption.click?eOption.click:function(){}}>{eOption?.label}</Box>
                    ):''
                }
            </PopoverBody>
        </PopoverContent>
    </Popover>
  )
}

export default TablePopUp